import { getMatchingAttributeConfig } from "api/getMatchingAttributeConfig";
import { SiteSurvey } from "api/types/siteSurvey";

import { SiteSurveyConfiguration } from "api/types/siteSurveyConfiguration";

export function SiteSummary({
  config,
  siteSurvey,
}: {
  config: SiteSurveyConfiguration;
  siteSurvey: SiteSurvey;
}) {
  return (
    <div className="mt-2">
      <h3>Site Summary</h3>
      {siteSurvey.attributes && (
        <div className="d-flex justify-content-center">
          <div className=" p-2" style={{ width: "70%" }}>
            <table className="table table-borderless table-striped table-sm ">
              <tbody>
                {siteSurvey.attributes.map((attribute, index) => {
                  const attributeConfig = getMatchingAttributeConfig(
                    config.attributes,
                    attribute
                  );
                  return (
                    <AttributeNameValue
                      key={`unitAttribute-${index}-${attribute.id}`}
                      name={attributeConfig.text}
                      value={attribute.attributeValue}
                    />
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
}

function AttributeNameValue({ name, value }) {
  return (
    <tr>
      <td>{name}</td>
      <td>{value}</td>
    </tr>
  );
}
